module.exports = __webpack_public_path__ + "static/media/logo.f1035b80.svg";